import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import {TIPO_SIMULADO} from '../../../const';

const isMobile = require('ismobilejs');

class FormConfigSimulado extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inExamBlockWindow: false,
            inContinueExam: false
        }

        this.onChangeDtInicio = this.onChangeDtInicio.bind(this);
        this.onChangeDtFim = this.onChangeDtFim.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    async componentDidMount() {
        let inExamBlockWindow = this.props.practiceContainer.state.simulado.inExamBlockWindow;
        let inContinueExam = this.props.practiceContainer.state.simulado.inContinueExam;

        // console.log('state.configurations',this.props.userContainer.state.configurations)
        // console.log('state.simulado',this.props.practiceContainer.state.simulado)

        if(inExamBlockWindow === undefined) inExamBlockWindow = this.props.userContainer.state.configurations.inCheckBlockWindow
        if(inContinueExam === undefined) inContinueExam = this.props.userContainer.state.configurations.inCheckContinueLater

        this.setState({inExamBlockWindow: inExamBlockWindow,inContinueExam: inContinueExam}, () => {
            this.props.practiceContainer.setState({
                simulado: { ...this.props.practiceContainer.state.simulado, inExamBlockWindow: inExamBlockWindow,  inContinueExam: inContinueExam}
            });
        });

    }

    getPracticeTestType(type) {
        if (type === TIPO_SIMULADO.DIAGNOSTICO) { return "Simulado Diagnóstico"; }
        if (type === TIPO_SIMULADO.DESENVOLVIMENTO) { return "Simulado Desenvolvimento"; }
        if (type === TIPO_SIMULADO.EVOLUCAO) { return "Simulado Evolução"; }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === 'inContinueExam') {
            this.setState({ inContinueExam: !this.state.inContinueExam })
        } else if (name === 'inExamBlockWindow') {
            this.setState({ inExamBlockWindow: !this.state.inExamBlockWindow })
        }
        this.props.practiceContainer.setState({
            simulado: { ...this.props.practiceContainer.state.simulado, [name]: value }
        });
        //  console.log([name] + " : " + value);
        this.configChanged = true
    }

    onChangeDtInicio(date) {
        //Caso tenha selecionado uma data inicial maior que a final
        if (date.getTime() > this.props.practiceContainer.state.simulado.dtEndEvent.getTime()) {
            this.props.practiceContainer.setState({
                simulado: { ...this.props.practiceContainer.state.simulado, dtStartEvent: date, dtEndEvent: date }
            });
        }
        else {
            this.props.practiceContainer.setState({
                simulado: { ...this.props.practiceContainer.state.simulado, dtStartEvent: date }
            });
        }
    }

    onChangeDtFim(date) {
        //Caso tenha selecionado uma data final menor que a inicial
        if (date.getTime() < this.props.practiceContainer.state.simulado.dtStartEvent.getTime()) {
            if(document.getElementById('inicio-agendamento').classList.contains('edb-disabled')) {
                this.props.practiceContainer.setState({
                    simulado: { ...this.props.practiceContainer.state.simulado, dtEndEvent: this.props.practiceContainer.state.simulado.dtStartEvent }
                });
            }
            else {
                this.props.practiceContainer.setState({
                    simulado: { ...this.props.practiceContainer.state.simulado, dtStartEvent: date, dtEndEvent: date }
                });
            }
        }
        else {
            this.props.practiceContainer.setState({
                simulado: { ...this.props.practiceContainer.state.simulado, dtEndEvent: date }
            });
        }
    }

    render() {
        const simulado = this.props.practiceContainer.state.simulado || {}
        // console.log('---> simulado',simulado)
        // console.log('action', this.props.practiceContainer.state.action)
        const isAgendar = (this.props.practiceContainer.state.action === 'agendar' || this.props.practiceContainer.state.action === 'forcarreagendar')
        const isEditar = this.props.practiceContainer.state.action === 'editar'
        const hasStarted = this.props.practiceContainer.state.simulado.hasStarted === 1;
        const isReagendar = this.props.practiceContainer.state.action === 'reagendar'

        return (
            <>
                <h4 className="edb-text-bold edb-margin-none">Passo 1: Configurar o {this.getPracticeTestType(this.props.practiceContainer.state.selectedPracticeTestType)}</h4>

                <div>Este simulado é obrigatório para todos os alunos</div>
                <div className="edb-row edb-margin-large-top">
                    <div className="edb-col s12">

                        <label>Data e hora de início</label>
                        <div id="inicio-agendamento" className={`adap-input-icon-container ${ hasStarted && isEditar && 'edb-disabled'}`}>
                            {simulado && <DatePicker className="adap-input edb-margin-bottom"
                                selected={simulado.dtStartEvent}
                                useWeekdaysShort
                                onChange={this.onChangeDtInicio}
                                startDate={simulado.dtStartEvent}
                                endDate={simulado.dtEndEvent}
                                selectsStart
                                showTimeSelect
                                dateFormat="dd/MM/yy HH:mm"
                                onFocus={(e) => (isMobile.any?e.target.readOnly = true:null)}
                                timeFormat="HH:mm"
                                timeCaption="Horário"
                                timeIntervals={5} />}
                            <i className="adap-input-icon far fa-calendar-alt"></i>
                        </div>

                        <label>Data e hora de término</label>
                        <div id="fim-agendamento" className="adap-input-icon-container">
                            {simulado && <DatePicker className="adap-input"
                                selected={simulado.dtEndEvent}
                                useWeekdaysShort
                                onChange={this.onChangeDtFim}
                                startDate={simulado.dtStartEvent}
                                endDate={simulado.dtEndEvent}
                                selectsEnd
                                showTimeSelect
                                dateFormat="dd/MM/yy HH:mm"
                                onFocus={(e) => (isMobile.any?e.target.readOnly = true:null)}
                                timeFormat="HH:mm"
                                timeCaption="Horário"
                                timeIntervals={5} />}
                            <i className="adap-input-icon far fa-calendar-alt"></i>
                        </div>
                        <p className="edb-text-red edb-small">Atenção, recomendamos um período menor que uma semana para o simulado. <a href={process.env.REACT_APP_WIKI+'/p/periodo-dos-simulados-x-resultados-e-estudos.html'} target="_blank" rel="noopener noreferrer" className="edb-btn-link">Saiba mais</a></p>
                    </div>
                    <div className="edb-col s12 edb-padding-left">

                        {/* <label>Dificuldade</label>
                    <select className="adap-input edb-margin-bottom" disabled={!!this.props.desabilitarInfoGeral} defaultValue="">
                        <option value="" disabled>Selecione...</option>
                        <option value="1">Fácil</option>
                        <option value="2">Intermediário</option>
                        <option value="3">Difícil</option>
                    </select>

                    <label>Tempo máximo de realização</label>
                    <select className="adap-input edb-margin-bottom" disabled={!!this.props.desabilitarInfoGeral} defaultValue="">
                        <option value="" disabled>Selecione...</option>
                        <option value="1">1h</option>
                        <option value="2">2h</option>
                        <option value="3">3h</option>
                        <option value="4">4h</option>
                        <option value="5">5h</option>
                    </select> */}

                        <label>
                            {(isAgendar || isReagendar || (!hasStarted && isEditar)) && <input type="checkbox" name="inExamBlockWindow" checked={this.state.inExamBlockWindow} onChange={this.handleInputChange} />}
                            {hasStarted && isEditar && <input className="edb-disabled" type="checkbox" name="inExamBlockWindow" checked={this.state.inExamBlockWindow} readOnly />}
                            <span>Habilita o bloqueio de mudança de janela</span>
                        </label>
                        <div className="edb-small edb-margin-bottom"><i>Esta opção fará com que a avaliação
                        do aluno seja gravada e encerrada ao sair da janela ou mudar de aba</i></div>

                        {/* <label className="edb-margin-bottom">
                            {(isAgendar || isReagendar || (!hasStarted && isEditar)) && <input type="checkbox" name="inContinueExam" checked={this.state.inContinueExam} onChange={this.handleInputChange} />}
                            {hasStarted && isEditar && <input className="edb-disabled" type="checkbox" name="inContinueExam" checked={this.state.inContinueExam} readOnly />}
                            <span>Habilitar "continuar depois"</span>
                        </label> */}
                    </div>
                </div>
            </>
        );
    }
}

export default FormConfigSimulado;